<template>
  <span class="site-brand" :class="{ 'is-inverse': inverse }" role="img" aria-label="万博体育">
    <template v-if="!imageFailed">
      <span class="site-brand-mark" aria-hidden="true">
        <img class="site-brand-source" :src="brandImage" alt="" draggable="false" @error="imageFailed = true" />
      </span>
      <span v-if="!markOnly" class="site-brand-wordmark" aria-hidden="true">
        <img class="site-brand-source" :src="brandImage" alt="" draggable="false" @error="imageFailed = true" />
      </span>
    </template>
    <span v-else class="site-brand-fallback" aria-hidden="true">{{ markOnly ? '万' : '万博体育' }}</span>
  </span>
</template>

<script setup>
import { ref } from 'vue'
import brandImage from '../assets/wanbo-brand-source-v3.webp'

defineProps({ inverse: Boolean, markOnly: Boolean })
const imageFailed = ref(false)
</script>

<style scoped>
.site-brand {
  display: inline-flex;
  flex: none;
  align-items: center;
  gap: var(--brand-gap, 8px);
  height: var(--brand-mark-size, 36px);
  line-height: 1;
}
.site-brand-mark,
.site-brand-wordmark {
  position: relative;
  display: block;
  flex: none;
  overflow: hidden;
  pointer-events: none;
}
.site-brand-source {
  position: absolute;
  display: block;
  max-width: none;
  pointer-events: none;
}
/* 与 kg-h5 共用品牌原图，分别保留球形 Logo 和字标的原始比例。 */
.site-brand-mark {
  width: var(--brand-mark-size, 36px);
  height: var(--brand-mark-size, 36px);
}
.site-brand-mark .site-brand-source {
  top: calc(var(--brand-mark-size, 36px) * -0.2462);
  left: calc(var(--brand-mark-size, 36px) * -0.542);
  width: calc(var(--brand-mark-size, 36px) * 3.9084);
  height: calc(var(--brand-mark-size, 36px) * 1.4656);
}
.site-brand-wordmark {
  width: calc(var(--brand-word-height, 24px) * 4.4286);
  height: var(--brand-word-height, 24px);
}
.site-brand-wordmark .site-brand-source {
  top: calc(var(--brand-word-height, 24px) * -1.2121);
  left: calc(var(--brand-word-height, 24px) * -3.6234);
  width: calc(var(--brand-word-height, 24px) * 8.8658);
  height: calc(var(--brand-word-height, 24px) * 3.3247);
}
.site-brand-fallback {
  color: var(--ink);
  font: italic 700 var(--brand-word-height, 24px)/1.2 "PingFang SC", "Microsoft YaHei", sans-serif;
  white-space: nowrap;
}
.is-inverse .site-brand-wordmark { filter: brightness(0) invert(1); }
.is-inverse .site-brand-fallback { color: #f3f5fa; }
</style>
